import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { LoadingService } from '../services/loading.service';

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoadingService);
  
  // No mostrar loading para ciertas peticiones
  const skipLoading = req.url.includes('/auth/') ||
                     req.url.includes('/health') ||
                     req.url.includes('/realtime') ||
                     req.url.includes('/chat') ||
                     req.url.includes('/analysis/') ||
                     req.url.includes('/test/entrevistador') ||
                     req.url.includes('/abogados/search') ||
                     req.url.includes('/slots') ||
                     req.url.includes('/catalogos/') ||
                     req.url.includes('/marketplace/') ||
                     req.url.includes('/agent-') ||
                     req.headers.has('skip-loading');
  
  if (skipLoading) {
    return next(req);
  }

  // Solo mostrar loading para peticiones que toman tiempo
  // No para peticiones rápidas como búsquedas o datos pequeños
  const isLongRequest = req.url.includes('/api/') && 
                       (req.method === 'POST' || req.method === 'PUT' || req.method === 'DELETE');

  if (isLongRequest) {
    loadingService.show();
  }

  return next(req).pipe(
    finalize(() => {
      if (isLongRequest) {
        loadingService.hide();
      }
    })
  );
};
